const ONE_DAY = 86400000; // 24 hours * 60 minutes * 60 seconds * 1000 milliseconds

export function isTrialExpired(trialEndDate) {
  return !!trialEndDate && new Date() > new Date(trialEndDate);
}

export function getRemainingTrialDays(trialEndDate) {
  const endDate = new Date(trialEndDate);
  const today = new Date();
  return Math.floor(Math.abs(Math.max((endDate - today) / ONE_DAY, 0)));
}

export function hasSpaceFreeTrial(space) {
  const hasPrivateProjectsSubscription = space?.hasPrivateProjectsSubscription;
  const trialPeriodEnd = space?.trialPeriodEnd;
  return (
    hasPrivateProjectsSubscription &&
    trialPeriodEnd &&
    !isTrialExpired(trialPeriodEnd)
  );
}
